/**
 * Свежая сборка на сервере — узнать из открытой вкладки.
 *
 * Вкладка, открытая до раскатки, живёт на старом коде, пока экран уже
 * загружен: `vite:preloadError` (`main.tsx`) ловит только чанк, которого на
 * диске нет. Разметка 20.10.26: владелец переключал правило подсорта и видел
 * экран до правки — сборка на сервере уже была новой.
 *
 * Номер сборки — имя входного скрипта `index-<хэш>.js` в `index.html`: Vite
 * меняет хэш с каждой сборкой, своего файла версии заводить не нужно.
 */

const ВХОД = /\/assets\/index-[\w-]+\.js/;

/** Входной скрипт из текста `index.html`; нет — `null` (dev-сервер, чужая страница). */
export function entryOf(html: string): string | null {
  return html.match(ВХОД)?.[0] ?? null;
}

/** Входной скрипт этой вкладки. */
export function currentEntry(): string | null {
  for (const script of Array.from(document.querySelectorAll<HTMLScriptElement>("script[type=module][src]"))) {
    const got = entryOf(new URL(script.src, location.href).pathname);
    if (got) return got;
  }
  return null;
}

/** На сервере другая сборка, чем во вкладке. Сеть упала или dev — `false`: молчать, а не дёргать. */
export async function serverHasNewBuild(): Promise<boolean> {
  const mine = currentEntry();
  if (!mine) return false;
  try {
    const answer = await fetch("/", { cache: "no-store", credentials: "same-origin" });
    if (!answer.ok) return false;
    const theirs = entryOf(await answer.text());
    return theirs !== null && theirs !== mine;
  } catch {
    return false;
  }
}
